import Vue from "vue";
import { Component } from "vue-property-decorator";

declare let M: any;
declare let $: any;

@Component
export default class SelectFieldController extends Vue {
  static refresh(): void {
    const selectElements = $("select");
    if (typeof selectElements.formSelect === "function") {
      selectElements.formSelect();
    } else {
      console.error("formSelect is not a function.");
    }

    const optionSpans = document.querySelectorAll(".dropdown-content>li span");
    optionSpans.forEach((span) => {
      if (!$.isNumeric(span)) {
        span.className += " primary-color";
      }
    });
  }
}
